<script setup>
import BigBanner from "~/components/molecules/BigBanner.vue";

const props = defineProps({
  banners: {
    type: Array,
  },
  settings: {
    type: Object,
    default: () => ({})
  }
})

const noAdaptive = computed(() => props.settings?.grid_mobile === true)
</script>

<template>
  <div class="g-32 shorter-gap" :class="{
    'grid-1': banners.length === 1,
    'grid-2': banners.length === 2 || banners.length === 4,
    'grid-3': banners.length === 3,
    'the-same-grid': noAdaptive,
    'no-adaptive': noAdaptive,
  }">
    <BigBanner :banner="banner" v-for="banner in banners"/>
  </div>
</template>

<style scoped lang="scss">
.no-adaptive {
  @include smd {
    gap: 6px !important;

    :deep(.big-banner) {
      margin-left: 0 !important;
      margin-right: 0 !important;
      width: 100% !important;
    }

    :deep(.banner-wrapper) {
      height: 100px !important;
    }

    :deep(.banner-block-text) {
      padding: 4px 5px !important;
      gap: 2px !important;
      flex: 0 0 45% !important;
      width: 45% !important;
      max-width: 45% !important;
      overflow: hidden !important;
      align-items: center !important;
    }

    :deep(.banner-block-image) {
      flex: 0 0 55% !important;
      width: 55% !important;
      max-width: 55% !important;
      min-width: 55% !important;
    }

    :deep(.banner-title) {
      font-size: 6px !important;
      line-height: 1.2 !important;
      overflow: hidden !important;
      display: -webkit-box !important;
      -webkit-line-clamp: 3 !important;
      -webkit-box-orient: vertical !important;
      line-clamp: 3 !important;
      max-width: 100% !important;
      width: 100% !important;
      text-align: center !important;
      word-break: break-word !important;
    }

    :deep(.banner-prices) {
      width: 100% !important;
      align-items: center !important;
    }

    :deep(.banner-price-text) {
      font-size: 7px !important;
    }

    :deep(.banner-current-price) {
      font-size: 7px !important;
    }

    :deep(.banner-button) {
      font-size: 5px !important;
      padding: 2px 4px !important;
      letter-spacing: 0 !important;
    }

    :deep(.banner-under-button-wrapper) {
      display: none !important;
    }
  }
}
</style>
